import { apiUrl, createApiClient, createAuthStore } from '@riskpay/ui-components';

/**
 * Quantum shares the employee identity provider but a separate session key, so
 * holding a Quantum session in one tab never grants the operations console in
 * another — and vice versa. The API enforces SUPER_ADMIN regardless.
 */
export const useAuth = createAuthStore('riskpay.quantum.session');

export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? apiUrl('/api/v1/quantum'),
  getToken: () => useAuth.getState().getToken(),
  onUnauthorized: () => useAuth.getState().signOut(),
});

export const authApi = createApiClient({
  baseUrl: import.meta.env.VITE_AUTH_URL ?? apiUrl('/api/v1/auth'),
  getToken: () => null,
  onUnauthorized: () => undefined,
});
